module.exports = __webpack_public_path__ + "img/service-banner3.559a33c4.png";